import { selectObject } from "utils/formUtils";
import { SET_COUNTRIES, UNSET_COUNTRIES } from "actions/types";

const INITIAL_STATE = {
  lastAction: null,
  countryOptions: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_COUNTRIES:
      const options = selectObject(
        action.payload,
        action.currentCountry ? action.currentCountry.id : 0
      );
      return { ...state, countryOptions: options, lastAction: "fetch" };
    case UNSET_COUNTRIES:
      if (state.countryOptions.length) {
        return { ...state, countryOptions: [], lastAction: null };
      }
      return state;
    default:
      return state;
  }
};
